<template>
  <div class="bg">
    <div class="book-name" style="width: 100%;margin-bottom: 3%;padding-top: 2%">
      <span>
        <span style="color: #744CE2;padding-right: 10px">当前课本:</span>
        {{book!=null?book.name:''}}
      </span>
    </div>
    <div class="content">
      <div class="card" @click="readReviewSize<5?toLearn('read',bookRecord.readUnitNo):toReview(readRecord,'read',bookRecord.readUnitNo)">
        <progress-card :pic="readPic" :bookWordCount="book!=null?book.words:0" :record="readRecord"></progress-card>
      </div>
      <!-- <div class="card" @click="toLearn('read',bookRecord.readUnitNo)">
        <progress-card :pic="readPic" :bookWordCount="book!=null?book.words:0" :record="readRecord"></progress-card>
      </div> -->
      <div class="card" @click="listenReviewSize<5?toLearn('listen',bookRecord.listenUnitNo):toReview(listenRecord,'listen',bookRecord.listenUnitNo)">
        <progress-card :pic="listenPic" :bookWordCount="book!=null?book.words:0" :record="listenRecord"></progress-card>
      </div>
      <div class="card" @click="writeReviewSize<5?toLearn('write',bookRecord.writeUnitNo):toReview(writeRecord,'write',bookRecord.writeUnitNo)">
        <progress-card :pic="writePic" :bookWordCount="book!=null?book.words:0" :record="writeRecord"></progress-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ReadPic from "./assets/read.png";
import ListenPic from "./assets/listen.png";
import WritePic from "./assets/write.png";

import ProgressCard from "./components/progress-card";

export default {
  components: {
    'progress-card': ProgressCard,
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  data() {
    return{
      baseApi: '/learn',
      readPic: ReadPic,
      listenPic: ListenPic,
      writePic: WritePic,
      book: null,
      bookRecord: null,
      readRecord: null,
      listenRecord: null,
      writeRecord: null,
      readReviewSize: 0,
      listenReviewSize: 0,
      writeReviewSize: 0,
    }
  },
  methods:{
    getBookRecord() {
      this.$fly.get(`${this.baseApi}/book/${this.info.current_book_id}`).then(b=>{
        this.book = b
        this.book.id = `${this.info.current_book_id}`
      })
      this.$fly.post(`${this.baseApi}/book-record/search-one`,{
          'studentAccountId.eLong':`${this.info.id}`,
          'bookId.eLong':`${this.info.current_book_id}`
        }).then((recordRes)=>{
          this.bookRecord = recordRes
          this.$fly.post(`${this.baseApi}/word-record/search`,{'localId.eLong':this.bookRecord.readRecordId}).then(r=>{
            this.readReviewSize = r[0].unsureWord.length+r[0].missWord.length
            this.readRecord = r[0]
          })
          this.$fly.post(`${this.baseApi}/word-record/search`,{'localId.eLong':this.bookRecord.listenRecordId}).then(l=>{
            this.listeneviewSize = l[0].unsureWord.length+l[0].missWord.length
            this.listenRecord = l[0]
          })
          this.$fly.post(`${this.baseApi}/word-record/search`,{'localId.eLong':this.bookRecord.writeRecordId}).then(w=>{
            this.writeReviewSize = w[0].unsureWord.length+w[0].missWord.length
            this.writeRecord = w[0]
          })
      })
    },
    toLearn(type,unitNo) {
      this.$router.push({
        name: '学习',
        params: {
          'type': type,
          'unitNo': unitNo,
          'book': this.book,
        }
      })
    },
    toReview(record,type,unitNo) {
      let words = record.unsureWord.concat(record.missWord)

      this.$router.push({
        name: '练习',
        params: {
          'name': `每日复习`,
          'type': 1,
          'questionCount': 300,
          'words': [words],
          'reviewOver': {
            'type': type,
            'unitNo': unitNo,
            'book': this.book,
          }
        }
      })
    }
  },
  created() {
    if (this.info == null) {
      this.$router.push('/login')
    } else {
      this.getBookRecord()
    }
  }
}
</script>

<style scoped>
.bg{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.card{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 40px;
}
.book-name{
  font-size: 30px;
  padding: 30px 0px 10px 0px;
}
@media screen and (max-width: 1400px) {
  .card{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px;
  }
  .book-name{
    font-size: 30px;
    padding: 10px 0px 10px 0px;
  }
}
</style>
